const joinArrayWith = (array: string[], join: string): string => {
    const lastItem = array.pop();

    if (!lastItem) {
        return '';
    }

    if (array.length === 0) {
        return lastItem;
    }

    return `${array.join(', ')} ${join} ${lastItem}`;
};

export default joinArrayWith;
